@import '~style-sheet-helpers/core.less';

.dropdown-toggler {
  margin: 0;
  width: 100%;
  height: 30px;
  align-items: center;

  && {
    background-color: transparent;
    border: 0;
  }
}

.checkbox {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.input {
  width: 100%;
  height: 26px;
}

.input-wrapper {
  display: flex;
  align-items: center;
  margin-top: 1px;
}

.date-link {
  font-size: 14px;
  display: flex;
  align-items: center;
  width: 100%;
}

.long-column-header {
  white-space: normal;
  line-height: 1;
  text-align: center;
  vertical-align: bottom;
}

.icon-wrapper {
  width: 16px;
  height: 16px;
  min-width: 16px;
  margin-left: 10px;
  display: flex;
  align-items: center;
}

.ship-from-column-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
